export { PageHomePageFormComponent as PageHomePageDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/homepage-form/index.tsx